<template>
    <div class="body">
      <div class="header">
        <el-form :model="LayoutManagementFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="文件名称">
              <el-input
                v-model="LayoutManagementFindDTO.name"
                placeholder="订单名称"
              ></el-input>
            </el-form-item>
          <el-form-item label="下载状态">
          <el-select clearable v-model="LayoutManagementFindDTO.downloadStatus" style="width:200px">
            <el-option
              v-for="item in downloadStatus"
              clearable
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="加工状态">
          <el-select clearable v-model="LayoutManagementFindDTO.confirmStatus" style="width:200px">
            <el-option
              v-for="item in confirmStatus"
              clearable
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-button class="btn-style btn-search" type="success" @click="serchInfo">搜索</el-button>
          <el-form-item>
            <el-button class="btn-style btn-download" @click="submit" type="primary">下载</el-button>
            <el-button class="btn-style btn-confirm" @click="confirmConfirmStatus" type="primary">加工</el-button>
            <el-button class="btn-style btn-cancel" @click="updateConfirmStatus" type="warning">取消加工</el-button>
            <el-button class="btn-style btn-redownload" @click="updateDownloadStatus" type="warning">重新下载</el-button>
            <el-button class="btn-style btn-redownload" @click="updateSubclassType" type="warning">雕刻完成</el-button>
            <el-button class="btn-style btn-redownload" @click="updateSubclassTypeV3" type="warning">待机雕刻</el-button>
            <el-button class="btn-style btn-redownload" @click="updateSubclassTypePlate" type="warning">设为余板</el-button>
            <el-button class="btn-style btn-redownload" @click="updateSubclassTypeV5" type="warning">重新出nc</el-button>
            <el-button class="btn-style btn-redownload" @click="updateSubclassTypeV4" type="warning">加急完成</el-button>
            <el-button class="btn-style btn-redownload" @click="updateSubclassTypeV6" type="warning">重新排版</el-button>
            <el-button class="btn-style btn-delete" type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
          <br>
          <el-form-item>
           产品: <el-button size="small" type="warning" v-for="item in AllLayoutManagementSet" :key="item" @click="find1(item)">
                {{ item }}
         </el-button>
          </el-form-item>
          <br>
        <el-form-item>
          材料: <el-button size="small" type="success" v-for="item in allSubclass" :key="item" @click="find(item)">
          {{ item }}
         </el-button>
        </el-form-item>
        </el-form>
        <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="新增其他文件"
        :visible.sync="drawer"
        width="25%"
      >
        <el-form
          ref="accountForm"
          :rules="rules"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
          <el-form-item label="发货方式" prop="deliveryMethod">
            <el-input
              class="input-name"
              size="small"
              v-model="accountForm.deliveryMethod"
              placeholder="请输发货方式"
            ></el-input>
          </el-form-item>
        <el-form-item  label="备注" prop="remake">
          <el-input
            class="input-remark"
            v-model="accountForm.remake"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>

          <el-form-item >
            <el-button
              size="small"
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
        <div style="display: flex">

          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <el-dialog title="编辑修图文件" :visible.sync="dialogVisible"  width="25%" :close-on-click-modal="false" class="order-dialog">
        <el-form
          ref="accountForm"
          :rules="rules"
          
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm form-style"
        >
        <el-form-item label="产品" prop="largeCategory">
            <el-select clearable v-model="accountForm.largeCategory" style="width:200px" allow-create  filterable @blur.native.capture="largeCategorySelect" @change="selectAllSubclass">
            <el-option
              v-for="item in largeCategory"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
          <el-form-item label="材料">
            <el-select clearable v-model="accountForm.subclass" style="width:200px" allow-create filterable @blur.native.capture="subclassSelect" @change="subclassSelect" >
            <el-option
              v-for="item in subclass"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
            </el-form-item>
            <el-form-item label="名称">
              <el-input
                v-model="accountForm.name"
                placeholder="名称"
              ></el-input>
            </el-form-item>
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </el-form>
      </el-dialog>

      <el-dialog title="剩余材料处理方式" :visible.sync="visible"  width="35%" :close-on-click-modal="false"  text-align="center"
                class="order-dialog"
                center>
        <div>
          <el-form
        ref="accountForm"
                    :model="accountForm"
                    class="demo-accountForm form-style"
        >
        <div class="accountForm-header">
    <el-radio v-model="radio1" label="1" border  size="medium">材料不下机雕刻</el-radio>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;雕完以后，材料留机床上，后面排版接着雕刻
  </div>
  <div class="accountForm-header">
    <el-radio v-model="radio1" label="2" border size="medium">雕刻完了换板材</el-radio>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 下次优先使用剩余料头
</div>
<div class="accountForm-header">
    <el-radio v-model="radio1" label="4" border size="medium">存入库存料头</el-radio>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 人工确认使用
</div>
<div class="accountForm-header">
    <el-radio v-model="radio1" label="3" border size="medium">我随便下载看看</el-radio>
</div>

<el-button   @click="editAccount1()"  type="success" round>确 定</el-button>
<el-button  @click="visible = false" type="danger" round>取 消</el-button>

        </el-form>
        </div>
      </el-dialog>
      <div class="pagination">
                    <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :header-cell-style="{borderColor:'#C0C0C0'}"
          :cell-style="{borderColor:'#C0C0C0'}"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="上传时间"
          ></el-table-column>
        <el-table-column
    prop="thumbnail"
    label="缩略图"
    align="center"
    width="100" >
 <template slot-scope="scope">
 <el-popover placement="top-start" trigger="click">
 <!--trigger属性值：hover、click、focus 和 manual-->
 <a :href="scope.row.thumbnail"  target="_blank" title="查看最大化图片">
 <img :src="scope.row.thumbnail" style="max-height: 800px;max-width: 800px">
  </a>
  <img slot="reference" :src="scope.row.thumbnail" style="max-height: 50px;max-width: 50px  cursor:pointer">
  </el-popover>
 </template>
</el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="文件名称"
          ></el-table-column>

          <el-table-column
            prop="largeCategory"
            align="center"
            label="产品"
          ></el-table-column>
          <el-table-column
            prop="subclass"
            align="center"
            label="材料"
          ></el-table-column>
          <!-- <el-table-column
            prop="materialEvaluation"
            align="center"
            label="用料评估"
          ></el-table-column> -->
        
          <el-table-column
            prop="layoutHeight"
            align="center"
            label="排版高度"
          ></el-table-column>
          <!-- <el-table-column
            prop="remainingHeight"
            align="center"
            label="排料高度"
          ></el-table-column> -->
          <el-table-column
            prop="fileNumber"
            align="center"
            label="文件数量"
          ></el-table-column>
          <el-table-column
            prop="availability"
            align="center"
            label="板材利用率"
          ></el-table-column>
          <el-table-column
            prop="downloadStatus"
            align="center"
            label="下载状态"
          >     <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.downloadStatus==='0'">未下载</el-tag>
            <el-tag type="success" v-if="scope.row.downloadStatus==='1'">已下载</el-tag>
        </template>
        </el-table-column>
          <el-table-column
            prop="confirmStatus"
            align="center"
            label="加工状态"
          >
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.confirmStatus==='0'">未加工</el-tag>
            <el-tag type="success" v-if="scope.row.confirmStatus==='1'">已加工</el-tag>
        </template></el-table-column>
        <el-table-column
            prop="subclassType"
            align="center"
            label="材料类型"
          >
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.subclassType==='0'">余板</el-tag>
            <el-tag type="success" v-if="scope.row.subclassType==='1'">整版</el-tag>
            <el-tag type="warning" v-if="scope.row.subclassType==='2'">料头</el-tag>
            <el-tag type="warning" v-if="scope.row.subclassType==='3'">待机料头</el-tag>
            <el-tag type="success" v-if="scope.row.subclassType==='4'">已完成</el-tag>
            <el-tag type="warning" v-if="scope.row.subclassType==='5'">加急</el-tag>
            <el-tag type="warning" v-if="scope.row.subclassType==='6'">完成加急</el-tag>
            <el-tag type="warning" v-if="scope.row.subclassType==='8'">库存料头</el-tag>
        </template></el-table-column>        <el-table-column
            prop="ncStatus"
            align="center"
            label="NC状态"
          >
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.ncStatus==='0'">未出nc</el-tag>
            <el-tag type="success" v-if="scope.row.ncStatus==='1'">已出nc</el-tag>
            <el-tag type="warning" v-if="scope.row.ncStatus==='2'">出nc中</el-tag>
            <el-tag type="warning" v-if="scope.row.ncStatus==='3'">出nc失败</el-tag>
        </template></el-table-column>
        
        <el-table-column label="操作" align="center" width="280">
        <template v-slot="{ row }">
          <el-link type="success" size="small" @click="downLoadHorizontal(row)"  v-if="row.horizontalNc">下载横版NC | </el-link>
          <el-link type="success" size="small" @click="downLoadVertical(row)" v-if="row.verticalNc">下载竖版NC | </el-link>
          <el-link type="" size="small" @click="handleEdit(row)">编辑</el-link>
        </template>
      </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </template>

  <script>
  const OSS = require('ali-oss');
  import JSZip from 'jszip'
  import FileSaver from 'file-saver'
  import {selectLayoutManagement,getSubclass,getLargeCategory,updateDownloadStatus,updateConfirmStatus,LayoutManagementBatchDelete,confirmConfirmStatus,updateSubclassType,updateSubclassTypePlate,updateSubclassTypeV3,updateSubclassTypeV4,updateSubclassTypeV5,updateSubclassTypeV6,updateSubclassTypeV7,upDateLayoutManagement,selectAllLargeCategory,selectAllSubclass} from '@/api/file/layout.js'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        radio1:'',
        multipleSelection: [],
        ids: '',
        allSubclass:[],
        confirmStatus:[{
          value: '0',
          label: '未加工'
        }, {
          value: '1',
          label: '已加工'
        }],
        downloadStatus: [{
          value: '0',
          label: '未下载'
        }, {
          value: '1',
          label: '已下载'
        }],
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]

        },
        AllLayoutManagementSet:'',
        date: '',
        largeCategory:[],
        subclass:[],
        conTract: [],
        LayoutManagementFindDTO:{
            name:'',
            startTime: '',
            endTime: '',
            largeCategory: '',
            subclass:'',
            access:'',
            confirmStatus:'0',
            downloadStatus:'',
        },
        drawer: false,
        visible:false,
        dialogVisible:false,
        accountForm:{
          id:'',
          access:'',
          largeCategory: '',
          subclass:'',
          deliveryMethod:'',
          deliveryTime:'',
          customerName:'',
          contacts:'',
          thumbnail:'',
          confirmStatus:'',
          downloadStatus:'',
          address:'',
          subclassType:'',
          ncStatus:''
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
            // deliveryMethod:[
            //         { required: true, message: '请输入发货方式', trigger: 'blur' }]
            },
            client: new OSS({
                // 你的Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                region: 'oss-cn-huhehaote',
                // 你的accessKeyId 和 accessKeySecret
                // 官方建议：阿里云账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM用户进行API访问或日常运维，请登录RAM控制台创建RAM用户。
                accessKeyId: 'LTAI5t7oe29RgGbGLzb5UE5X',
                accessKeySecret: 'oFp52wXNyHG9YW7opk3uMo1rgbYzYD',
                // 你的Bucket名称。
                bucket: 'service-center-liuchi'
            })
      }
    },
    mounted() {
      this.LayoutManagementFindDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 *2)
        this.LayoutManagementFindDTO.startTime= start
        const end = new Date()
        this.LayoutManagementFindDTO.endTime= end
        this.date=[start,this.LayoutManagementFindDTO.endTime]
        this.selectAllLargeCategory()
      this.getAllLayoutManagementSet()
      // 进入页面调用一次获取数据的方法
    },
    methods: {
      editAccount1(){
        this.multipleSelection=[]
            this.multipleSelection.push(this.accountForm)
          if(this.radio1==1){
              this.updateSubclassTypeV3()
          }else if(this.radio1==2){
            this.updateSubclassType()
          }else if(this.radio1==4){
            this.updateSubclassTypeV7()
          }
          this.visible=false
      },
      selectAllLargeCategory(){
        selectAllLargeCategory(localStorage.getItem("access")).then((res) => {
        if(res.data.msg === '操作成功'){
            this.largeCategory=res.data.data;
        }
      })
      },
        selectAllSubclass(){
          selectAllSubclass(this.accountForm).then((res) => {
        if(res.data.msg === '操作成功'){
            this.subclass=res.data.data;
        }
      })
      },
      largeCategorySelect(e) {
                if(e.target.value) { 
                    this.accountForm.largeCategory = e.target.value
            }
        },
      subclassSelect(e) {
                if(e.target.value) { 
                    this.accountForm.subclass = e.target.value
            }
        },
       //修改
   editAccount() {
    console.log(this.accountForm)
    upDateLayoutManagement(this.accountForm).then((res) => {
          console.log(res.status)
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getAllLayoutManagementSet()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      find(data){
        this.LayoutManagementFindDTO.subclass=data
       this.getTable();
    },
    async   find1(data){
      this.LayoutManagementFindDTO.largeCategory=data
      await  getSubclass(this.LayoutManagementFindDTO).then((res)=>{
            if(res.data.code===10000){
              this.allSubclass=res.data.data
              this.LayoutManagementFindDTO.subclass=res.data.data[0];
            }
      })
       this.getTable();
    },
    async   getAllLayoutManagementSet(){
      await   getLargeCategory(this.LayoutManagementFindDTO).then((res) => {
        if(res.data.code===10000){
            this.AllLayoutManagementSet=res.data.data;
            this.LayoutManagementFindDTO.largeCategory=res.data.data[0];
        }
           getSubclass(this.LayoutManagementFindDTO).then((res)=>{
            if(res.data.code===10000){
              this.allSubclass=res.data.data
              this.LayoutManagementFindDTO.subclass=res.data.data[0];
              this.getTable()
            }
      })
        })

    },
    updateDownloadStatus(){
      updateDownloadStatus(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '返回未未下载状态成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },

    
    updateSubclassType(){
      updateSubclassType(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '成功变更为余料!',
              }),
              this.getTable()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    
    updateSubclassTypeV3(){
      updateSubclassTypeV3(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '成功变更为余料!',
              }),
              this.getTable()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateSubclassTypeV7(){
      updateSubclassTypeV7(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '成功变更为库存料头!',
              }),
              this.getTable()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateSubclassTypeV4(){
      updateSubclassTypeV4(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '成功变更为余料!',
              }),
              this.getTable()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateSubclassTypeV5(){
      updateSubclassTypeV5(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '成功重新出nc!',
              }),
              this.getTable()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateSubclassTypeV6(){
      updateSubclassTypeV6(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '成功重新排版!',
              }),
              this.getTable()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateSubclassTypePlate(){
      updateSubclassTypePlate(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '成功变更为余料!',
              }),
              this.getTable()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    confirmConfirmStatus(){
      confirmConfirmStatus(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '返回为未加工状态成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    updateConfirmStatus(){
      updateConfirmStatus(this.multipleSelection).then((res)=>{
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
        if(res.data.code===10000){
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '返回为未确认状态成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            }
      })
    },
    submit() {
                let temp = this.multipleSelection
                let urls = []
                for (let i = 0; i < temp.length; i++) {
                    let a = {
                        fileUrl: temp[i].path,
                        renameFileName: temp[i].name
                    }
                    urls.push(a)
                }
                console.log(urls)
                this.filesToRar(urls)
            },
            /**文件打包
             * arrImages:文件list:[{fileUrl:文件url,renameFileName:文件名}]
             * filename 压缩包名
             * */
            filesToRar(arrImages) {
                let _this = this;
                let zip = new JSZip();
                let cache = {};
                let promises = [];
                _this.$message.success('正在下载请稍等！！！！');
                for (let item of arrImages) {
                    const promise = _this.getImgArrayBuffer(item.fileUrl).then(data => {
                        // 下载文件, 并存成ArrayBuffer对象(blob)
                        zip.file(item.renameFileName, data, {
                            binary: true
                        }); // 逐个添加文件
                        cache[item.renameFileName] = data;
                    });
                    promises.push(promise);
                }

                Promise.all(promises).then(() => {
                    zip.generateAsync({
                        type: "blob"
                    }).then(content => {
                        // 生成二进制流
                        FileSaver.saveAs(content, this.getCurrentTime()); // 利用file-saver保存文件  自定义文件名
                        _this.$message.success('压缩完成');
                    });
                }).catch(res => {
                    _this.$message.success('压缩失败');
                });
            },
            //获取文件blob
            getImgArrayBuffer(url) {
                let _this = this;
                return new Promise((resolve, reject) => {
                    //通过请求获取文件blob格式
                    let xmlhttp = new XMLHttpRequest();
                    xmlhttp.open("GET", url, true);
                    xmlhttp.responseType = "blob";
                    xmlhttp.onload = function() {
                        if (this.status == 200) {
                            resolve(this.response);
                        } else {
                            reject(this.status);
                        }
                    }
                    xmlhttp.send();
                });

            },
      async   downLoadHorizontal(row) {
      let file_name=row.horizontalNc;
      let app = this;
      getStream();
     this.accountForm=row;
     if(row.subclassType=='0'){
      this.visible=true;
     }else if(row.subclassType=='1'){
      this.$confirm('请确定是否存入已加工库？\n\n请确认！！！！！', '是否存入已加工库', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.multipleSelection=[]
            this.multipleSelection.push(row)
        confirmConfirmStatus(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '更改成功!',
              }),
              this.getTable()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
     }
            // 下载函数
            async function getStream() {
                try {
                  console.log(file_name)
                    // 自定义响应头
                    // 获取下载文件的签名URL，配置文件HTTP头中的Content-Disposition为attachment，实现浏览器访问时自动下载文件，并自定义下载后的文件名称。
                    const response = {
                        'content-disposition': `attachment; filename=${encodeURIComponent(file_name)}`
                   
                    };
                    const url = app.client.signatureUrl(file_name, { response });
                    // 新窗口打开URL
                    window.open(file_name);
                } catch (err) {
                    // 全局提示
                    this.$message({
              type: "error",
              message: "sorry,目前只支持单个文件下载!"
            });
                    控制台答应错误
                    console.error(err);
                }
            }
            // 开始下载
           

    },
    downLoadVertical(row) {
      let file_name=row.verticalNc;
      let app = this;
      this.accountForm=row;
      console.log(row.subclassType)
      if(row.subclassType=='0'){
      this.visible=true;
     }else if(row.subclassType=='1'){
      this.$confirm('请确定是否存入已加工库？\n\n请确认！！！！！', '是否存入已加工库', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.multipleSelection=[]
            this.multipleSelection.push(row)
        confirmConfirmStatus(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '更改成功!',
              }),
              this.getTable()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
     }
            // 下载函数
            async function getStream() {
                try {
                  console.log(file_name)
                    // 自定义响应头
                    // 获取下载文件的签名URL，配置文件HTTP头中的Content-Disposition为attachment，实现浏览器访问时自动下载文件，并自定义下载后的文件名称。
                    const response = {
                        'content-disposition': `attachment; filename=${encodeURIComponent(file_name)}`
                   
                    };
                    const url = app.client.signatureUrl(file_name, { response });
                    // 新窗口打开URL
                    window.open(file_name);
                } catch (err) {
                    // 全局提示
                    this.$message({
              type: "error",
              message: "sorry,目前只支持单个文件下载!"
            });
                    控制台答应错误
                    console.error(err);
                }
            }
            // 开始下载
            getStream();
            
    },
    getCurrentTime() {
        //获取当前时间并打印
        var _this = this;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth()+1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    _this.gettime = yy+'年'+mm+'月'+dd+'日'+hh+'点'+mf+'分'+ss+'秒';
    console.log(_this.gettime)
    return _this.gettime;
    },
      today(){
        const start = new Date()
        start.setTime(start.getTime())
        this.LayoutManagementFindDTO.startTime= start
        const end = new Date()
        end.setTime(end.getTime())
        this.LayoutManagementFindDTO.endTime= end
        this.getTable()
      },

      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTable()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTable()
      },

      getTable(){
        selectLayoutManagement(this.currentPage, this.pageSize, this.LayoutManagementFindDTO).then((res) => {
            //console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
   //修改

      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTable()
            }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            LayoutManagementBatchDelete(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.LayoutManagementFindDTO.startTime = e[0]
          this.LayoutManagementFindDTO.endTime = e[1]
        } else if (!e) {
          this.LayoutManagementFindDTO.startTime = ''
          this.LayoutManagementFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getAllLayoutManagementSet()
      },

    }
  }
  </script>
  
<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
}

.body {
    overflow: auto;
}

.pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
}

.el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
.goodsTableData{
    margin: 20px 0 ;
}
.btn-style{
    min-width: 72px;
    border-radius: 8px;
}
.btn-search{
    background: var(--theme-color);
}
.btn-buy{
    background: #FF8429;
}
.btn-print{
    background: #4093FF;
}
.btn-delete{
    background: #FF4D4D;
}
.btn-view{
    background: var(--theme-color);
}
.product-form .el-form-item{
    margin-bottom: 0;
}
.table-content{
    margin: 20px;
}
.check-all{
    color: #333;
    font-size: 16px;
    margin-right: 20px;
    cursor: pointer;
}
.el-pagination{
    margin: 0;
}

.el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
    border-radius: 8px;
}

.table-label{
    color: var(--secondColor);
}
.table-value{
    color: var(--color);
}
.table-info{
    width: 80%;
    justify-content: space-between;
}
.table-info > p{
    display: inline-block;
    width: 150px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}
.table-item{
    background: #F7F7F7;
    margin: 8px 0;
    border-radius: 12px;
    padding: 12px;
}
.table-image{
    width: 100px;
    height: 50px;
    margin-right: 20px;
}
::v-deep.table-image .image-slot{
    height: 50px;
    display: flex;
    align-items: center;
}
::v-deep.table-image .image-slot i{
    font-size: 50px;
}
.pay{
    color:var(--theme-color);
}
.no-pay{
    color:#FF4D4D;
}
.btn-group{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.btn-group .el-button{
    border-radius: 20px;
    width: 76px;
}
.btn-collection{
    background: #F9DDDD;
}
.btn-view-detail{
    background: #D3F2E4;
    color: var(--theme-color);
}
.btn-reckon{
    background: rgb(245, 233, 212);
  
}

::v-deep.order-dialog .el-dialog{
    border-radius: 24px;
}
.operator label{
    letter-spacing: 5px;
}
::v-deep.dialog-upload{
    display: flex;
}
::v-deep.dialog-upload .el-form-item__label{
    flex-shrink: 0;
}
::v-deep.dialog-upload .el-form-item__content{
    justify-content: right;
}
::v-deep.dialog-upload .avatar-uploader{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #D8E0DD;
}
::v-deep.dialog-upload .el-upload--text{
    width: 100%;
    height: 100%;
}
::v-deep.dialog-upload img{
    max-width: 100px;
}
.accountForm-header{
    background: #F7F7F7;
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 20px;
}
.btn-add{
    background: #FF8429;
    border-radius: 8px;
}
.form-submit{
    background: var(--theme-color);
    border-radius: 8px;
}
::v-deep.el-table thead th{
    background: #EAF4F0;
    color: var(--secondColor);
}
.table-no-pay{
    background: #ffeded;
}

::v-deep.el-icon-remove-outline{
    font-size: 32px;
    color: #a3d8f9cc;
}
</style>